import { relativeCoord } from "./coordinates";
import cssValue from "./variable.module.scss";

export const stickySize = parseInt(cssValue.stickySize);
export const fakeZoom = parseInt(cssValue.fakeZoom);
// Board scaling baselines — used by ArtObjectivesBoard.vue to size cells and
// convert window CSS-px to baseline-px for the packing algorithm.
export const baselineFontPx = parseFloat(cssValue.baselineFontPx);
export const baselineWidth = parseFloat(cssValue.baselineWidth);
export const verticalBaselineHeight =
  (baselineFontPx / parseFloat(cssValue.verticalBoardFontSize)) * 100;

const MILLI_SECONDS = 1;
export const SECONDS = 1000;
export const MINUTES = 60 * SECONDS;
export const HOURS = 60 * MINUTES;
export const DAYS = 24 * HOURS;

export const boardAspect = 16 / 9;
export const zoomFactor = relativeCoord(0.018, 0.018 * boardAspect);
export const arrowLen = relativeCoord(0.005, 0.005 * boardAspect);
export const arrowAngle = Math.PI * (1 - 20 / 180); // 20 degrees
export const longClick = 0.5 * SECONDS;
export const longClickDist = 50;
export const dragStartDist = 16;
export const minZoom = 1;
export const maxZoom = 10;
export const minCardSizeFactor = 1;
export const maxCardSizeFactor = 8;
export const defaultCardSizeFactor = 3;
export const cardZoomHeight = 0.3333;
export const moveSendPeriod = 5 * SECONDS;
export const moveSendPerPeriod = 50;
export const maxMoveSendPerPeriod = 100;
export const moveAnimationDelay = 45 * MILLI_SECONDS;
export const moveAnimationStep = 0.20001;
export const statHistory = 1000;
export const pointerPosInterval = 60 * MILLI_SECONDS;
export const pointerPosHide = 30 * SECONDS;
export const pointerTrailMaxLen = 50;
export const pointerTrailDotDist = 8;
export const keepEndedTimer = 10 * SECONDS;
export const timerEnding = 2 * MINUTES;
export const userHeartbeatInterval = 3 * SECONDS;
export const maxVisibleUsersOnBoard = 4;
export const natsRequestTimeout = 15 * SECONDS;
export const natsTabInactiveRequestTimeout = 60 * SECONDS;
export const iterationSyncTimeout = 2 * MINUTES;
export const backlogSyncTimeout = 5 * MINUTES;
export const updateTimeout = 500 * MILLI_SECONDS;
export const screenShotWidth = 10000;
export const snapDistance = 0.0002;
export const regionZoomSteps = 30;
export const regionZoomDelay = 20 * MILLI_SECONDS;
